import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'tooltip',
  props: {
    array: {
      type: Array,
      default: null
    },
    text: {
      type: [String, Number],
      default: null
    },
    position: {
      type: String,
      default: 'left'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    overflowHidden: {
      type: Boolean,
      default: true
    },
    isContentClickable: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      default: ''
    },
    object: {
      type: Object,
      default: null
    },
    slotContent: {
      type: Boolean,
      default: false
    },
    objectsSeparator: {
      type: String,
      default: ''
    },
    // If set to true, this will always be open, useful for debugging purposes...
    debugShow: {
      type: Boolean,
      default: false
    },
    closeDelay: {
      type: Number,
      default: 0
    },
    activatorClass: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const modelValue = ref(props.debugShow || false);
    watch([() => modelValue.value, () => props.debugShow], () => {
      if (props.debugShow) {
        modelValue.value = true;
      }
    });
    return {
      __sfc: true,
      props,
      modelValue
    };
  }
});